import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import {
  Children,
  Container,
  Item,
  ItemText,
  Label,
} from "scmp-app/components/hamburger-menu/hamburger-menu-default/hamburger-menu-item/accordion-list/styles";
import type { topicsMenuItemQueueItemsEdge$key } from "scmp-app/queries/__generated__/topicsMenuItemQueueItemsEdge.graphql";

type Props = {
  className?: string;
  label?: string;
  reference: topicsMenuItemQueueItemsEdge$key;
  type: string;
};
export const MenuItemTopic: FunctionComponent<Props> = ({ className, label, reference, type }) => {
  const topics = useFragment(
    graphql`
      fragment topicsMenuItemQueueItemsEdge on QueueItemsEdge @relay(plural: true) {
        node {
          __typename
          ... on Topic {
            name
            urlAlias
          }
        }
      }
    `,
    reference,
  );

  if (!topics) return null;

  return (
    <Container className={className}>
      <Label>{label}</Label>
      <Children $type={type}>
        {topics
          .filter(({ node }) => node !== null)
          .map(({ node }, index) => {
            if (node.__typename !== "Topic") return null;
            return (
              <Item key={index} pathname={node.urlAlias}>
                <ItemText>{node.name}</ItemText>
              </Item>
            );
          })}
      </Children>
    </Container>
  );
};
